import axiosInstance from "../http/axios_instance"
const http = axiosInstance("/protected/admin",  null, "/forbidden")

const getOrganisations = () => http.get("/organisations");
const getOrganisation = (id) => http.get("/organisations?organisation_id=" + id);
const newOrganisation = (body) => http.post("/organisations", body);
const putOrgAddress = (org_id, body) => http.put("/organisation_address/"+org_id, body)
const postOrgRicsTerms = (org_id, body) => http.post("/organisation_rics_terms/"+org_id, body)
const getOrgRicsTerms = (org_id) => http.get("/organisation_rics_terms/"+org_id)
const putOrgRicsTerms = (org_id) => http.put("/organisation_rics_terms/"+org_id)
const putOrgNotifications = (org_id, body) => http.put("/notifications/" + org_id, body)
const getOrgNotificationList = (org_id) => http.get("/notification_list/" + org_id)
const putOrgNotificationList = (org_id, body) => http.put("/notification_list/" + org_id, body)
const postOrgNotificationList = (org_id, body) => http.post("/notification_list/" + org_id, body)
const putCommercialValuations = (org_id, body) => http.put("/commercial_valuations/" + org_id, body)
const getCommercialValuations = (org_id) => http.get("/commercial_valuations/" + org_id)
const putReportLengthChooseAllow = (org_id, body) => http.put("/report_length_choose_allow/" + org_id, body)
const postDefaultReportLength = (org_id, body) => http.post("/default_report_length/" + org_id, body)

export default {
    getOrganisations,
    getOrganisation,
    newOrganisation,
    putOrgAddress,
    getOrgRicsTerms,
    putOrgRicsTerms,
    postOrgRicsTerms,
    putOrgNotifications,
    getOrgNotificationList,
    putOrgNotificationList,
    postOrgNotificationList,
    putCommercialValuations,
    getCommercialValuations,
    putReportLengthChooseAllow,
    postDefaultReportLength
}
